import type {
  Params,
  UpdateUserResponse,
  User,
  UserListResponse,
  UserRequest,
} from '@/domains/system-management/types/user';
import { APIS, URLS } from '@/shared/config/urls';
import { request } from '@/shared/utils/request';

export const userApi = {
  // Get user list
  getUsers: async (params: Params): Promise<UserListResponse[]> => {
    const queryParams = new URLSearchParams();
    Object.entries(params).forEach(([key, value]) => {
      if (value !== undefined) {
        queryParams.append(key, value.toString());
      }
    });
    const url = `${URLS.BACK_DSH}${APIS.usersList(queryParams.toString())}`;
    return request.get(url);
  },

  // Get user details
  getUser: async (id: string): Promise<User> => {
    const url = `${URLS.BACK_DSH}${APIS.detailUser(id)}`;
    return request.get(url);
  },

  // Create user
  createUser: async (data: UserRequest): Promise<{ id: string }> => {
    const url = `${URLS.BACK_DSH}${APIS.createUser}`;
    return request.post(url, data);
  },

  // Update user
  updateUser: async (data: UserRequest): Promise<UpdateUserResponse> => {
    const url = `${URLS.BACK_DSH}${APIS.updateUser}`;
    return request.put(url, data);
  },

  // Delete user
  deleteUser: async (id: string): Promise<void> => {
    const url = `${URLS.BACK_DSH}${APIS.deleteUser(id)}`;
    return request.delete(url, id);
  },
};
